export default __webpack_public_path__ + "06b9d19ced8d17f3d5cbd5f1cbb31460.svg";